import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Input } from 'antd';
import PropTypes from 'prop-types';
import s from './changeDealer.less';

const { Search } = Input;

class Popup extends Component {
  static propTypes = {
    isPopupOpen: PropTypes.bool,
    header: PropTypes.element,
    children: PropTypes.any,
    onPopupClose: PropTypes.func,
  };
  render() {
    return (
      <div>
        {this.props.isPopupOpen && (
          <div className={s.overlay}>
            <div className={s.popup}>
              <div className="popup__header">{this.props.header}</div>
              <div className={s.popup__content}>
                <div
                  className={s.popup__close}
                  onClick={this.props.onPopupClose}
                >
                  &times;
                </div>
                {this.props.children}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// eslint-disable-next-line react/no-multi-comp
class ChangeDealer extends React.Component {
  static propTypes = {
    select: PropTypes.func,
    activeDealerId: PropTypes.number,
  };
  state = {
    isPopupOpen: false,
    dealers: [],
    search: '',
  };
  async componentDidMount() {
    try {
      const dealers = await fetch('/customer/get-dealers');
      this.setState({
        dealers,
      });
    } catch (e) {
      this.setState({ error: (e.error || e).toString() });
    }
  }

  togglePopup = () => {
    this.setState({ isPopupOpen: !this.state.isPopupOpen });
  };

  changeDealer = dealer => {
    this.props.select(dealer);
    this.togglePopup();
  };

  render() {
    return (
      <div className={s['active-dealer']}>
        <Popup
          isPopupOpen={this.state.isPopupOpen}
          onPopupClose={() => {
            this.setState({ isPopupOpen: false });
          }}
          header={
            <div>
              <div className={s.dealers__title}>
                Select a different servicing dealer
              </div>
              <Search
                placeholder="Search by name"
                onChange={e =>
                  this.setState({ search: e.target.value.toLowerCase() })
                }
                style={{ width: 200 }}
                value={this.state.search}
              />
              <div className={s.dealer}>
                <div className={`${s['dealer__header-item']} col-xs-4`}>
                  Name
                </div>
                <div className="col-xs-3">Telephone</div>
                <div />
              </div>
            </div>
          }
        >
          {this.state.error && (
            <Alert message={this.state.error} type="error" />
          )}
          <div>
            {this.state.dealers
              .filter(
                x =>
                  x.companyName.toLowerCase().indexOf(this.state.search) >= 0,
              )
              .map(dealer => (
                <div className={s.dealer} key={dealer.id}>
                  <div>
                    <div className={s.dealer__title}>{dealer.companyName}</div>
                    <div>
                      {dealer.addressLine1} {dealer.addressLine2},{' '}
                      {dealer.postcode}
                    </div>
                    {dealer.id === this.state.sellingDealer && (
                      <div className="bold">Selling Dealer</div>
                    )}
                  </div>
                  <div className="col-xs-3">
                    <div>{dealer.phone}</div>
                  </div>
                  <div className="col-xs-1 ">
                    {this.props.activeDealerId !== dealer.id ? (
                      <Button
                        type="primary"
                        onClick={() => this.changeDealer(dealer)}
                      >
                        Select
                      </Button>
                    ) : (
                      <Button type="primary" disabled>
                        Active dealer
                      </Button>
                    )}
                  </div>
                </div>
              ))}
            <div className={s.dealer__action}>
              <Button onClick={this.togglePopup}>Cancel</Button>
            </div>
            <div />
          </div>
        </Popup>

        <div className="col-sm-12">
          <div className="sp-garage-info">
            <div>
              <Button onClick={this.togglePopup}>Change Dealer</Button>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(ChangeDealer);
